const TwButton = ({
    color,
    size,
    style,
    className,
    icon,
    tooltip,
    rightIcon,
    leftIcon,
    onClick,
    children,
    disabled }: {
        color?: any,
        size?: any,
        style?: any,
        className?: any,
        icon?: any,
        tooltip?: any,
        rightIcon?: any,
        leftIcon?: any,
        onClick?: any,
        children?: any,
        disabled?: any
    }) => {
    rightIcon = rightIcon ? rightIcon.split(" ") : undefined
    leftIcon = leftIcon ? leftIcon.split(" ") : undefined
    color = color ?? "primary"
    if (color == "accent") {
        color = "secondary"
    }
    if (color == "warn") {
        color = "danger"
    }
    // const colorMappings = {
    //     primary: "blue",
    //     secondary: "zinc",
    //     danger: "red",
    //     success: "green",
    // }
    // const darkColorMappings = {
    //     primary: "zinc",
    //     secondary: "gray",
    //     danger: "red",
    //     success: "green",
    // }
    // const lightColor = colorMappings[color] ?? "transparent"
    // const darkColor = darkColorMappings[color] ?? lightColor
    const cssClass = [
        `btn`,
        color,
        `rounded`,
        `text-sm`,
        `flex`,
        `items-center`,
        `justify-center`,
        className ?? ""
    ]
    if (style == "outline") {
        cssClass.push(
            `[&.primary]:text-blue-700`,
            `hover:text-zinc-200`,
            `dark:hover:text-zinc-200`,
            `border`,
            `focus:ring-4`,
            `focus:outline-none`,
            `[&.primary]:border-blue-700`,
            `[&.primary]:hover:bg-blue-800`,
            `[&.primary]:focus:ring-blue-300`,
            `[&.primary]:dark:border-zinc-500`,
            `[&.primary]:dark:hover:bg-zinc-500`,
            `[&.primary]:dark:focus:ring-zinc-800`,
            `[&.secondary]:border-zinc-700`,
            `[&.secondary]:hover:bg-zinc-800`,
            `[&.secondary]:focus:ring-zinc-300`,
            `[&.secondary]:dark:border-zinc-500`,
            `[&.secondary]:dark:hover:bg-gray-500`,
            `[&.secondary]:dark:focus:ring-gray-800`,
            `[&.danger]:text-red-700`,
            `[&.danger]:hover:text-red-100`,
            `[&.danger]:border-red-700`,
            `[&.danger]:hover:bg-red-800`,
            `[&.danger]:focus:ring-red-300`,
            `[&.danger]:dark:border-red-500`,
            `[&.danger]:dark:hover:bg-red-500`,
            `[&.danger]:dark:focus:ring-red-800`,
            `[&.success]:hover:bg-green-800`,
            `[&.success]:focus:ring-green-300`,
            `[&.success]:dark:border-green-500`,
            // `[&.light]:hover:bg-green-800`,
            // `[&.light]:focus:ring-green-300`,
            // `[&.light]:dark:border-green-500`,
        )
    }
    else if (style == "light") {
        cssClass.push(
            `focus:ring-2`,
            `focus:outline-none`,
            `[&.primary]:text-blue-800`,
            `[&.primary]:dark:text-blue-200`,
            `[&.primary]:focus:ring-blue-300`,
            `[&.primary]:dark:focus:ring-blue-800`,
            `[&.secondary]:text-zinc-800`,
            `[&.secondary]:dark:text-zinc-200`,
            `[&.secondary]:focus:ring-zinc-300`,
            `[&.secondary]:dark:focus:ring-gray-500`,
            `[&.danger]:text-orange-800`,
            `[&.danger]:dark:text-orange-200`,
            `[&.danger]:focus:ring-orange-300`,
            `[&.danger]:dark:focus:ring-gray-500`,
        )
    }
    else {
        cssClass.push(
            `text-white`,
            `focus:ring-4`,
            `focus:outline-none`,
            `[&.primary]:bg-gray-600`,
            `[&.primary]:hover:bg-gray-800`,
            `[&.primary]:focus:ring-gray-300`,
            `[&.primary]:dark:bg-zinc-600`,
            `[&.primary]:dark:hover:bg-zinc-700`,
            `[&.primary]:dark:focus:ring-zinc-800`,
            `[&.secondary]:bg-amber-600`,
            `[&.secondary]:hover:bg-amber-800`,
            `[&.secondary]:focus:ring-amber-300`,
            `[&.secondary]:dark:bg-zinc-600`,
            `[&.secondary]:dark:hover:bg-zinc-700`,
            `[&.secondary]:dark:focus:ring-zinc-800`,
            `[&.danger]:bg-red-600`,
            `[&.danger]:hover:bg-red-800`,
            `[&.danger]:focus:ring-red-300`,
            `[&.success]:bg-green-600`,
            `[&.success]:hover:bg-green-800`,
            `[&.success]:focus:ring-green-300`,
            // `[&.light]:bg-green-600`,
            // `[&.light]:hover:bg-green-800`,
            // `[&.light]:focus:ring-green-300`,
        )
    }
    const iconClasses = [
        `fal`,
    ]
    if (icon) {
        iconClasses.push(`fa-${icon}`)
    }
    let px = 4
    let py = 2
    if (size == "sm") {
        px = 2
        py = 1
    }
    if (children) {
        iconClasses && iconClasses.push(`ms-2`)
        rightIcon && rightIcon.push(`me-2`)
        leftIcon && leftIcon.push(`ms-2`)
    }
    else {
        px = 2
        // iconClasses.push("fa-sm")
    }
    cssClass.push(
        `px-${px}`,
        `py-${py}`,
    )
    let iconStyle = "fat"
    style == "light" && (iconStyle = "fal")
    if (rightIcon) {
        rightIcon.includes('far') && rightIcon.splice(rightIcon.indexOf('far'), 1)
        rightIcon.includes('fal') && rightIcon.splice(rightIcon.indexOf('fal'), 1)
        rightIcon.includes('fat') && rightIcon.splice(rightIcon.indexOf('fat'), 1)
        rightIcon.includes('fad') && rightIcon.splice(rightIcon.indexOf('fad'), 1)
        !rightIcon.includes(iconStyle) && rightIcon.push(iconStyle)
        !rightIcon.includes('fa-fw') && rightIcon.push('fa-fw')
    }
    if (leftIcon) {
        leftIcon.includes('far') && leftIcon.splice(leftIcon.indexOf('far'), 1)
        leftIcon.includes('fal') && leftIcon.splice(leftIcon.indexOf('fal'), 1)
        leftIcon.includes('fat') && leftIcon.splice(leftIcon.indexOf('fat'), 1)
        leftIcon.includes('fad') && leftIcon.splice(leftIcon.indexOf('fad'), 1)
        !leftIcon.includes(iconStyle) && leftIcon.push(iconStyle)
        !leftIcon.includes('fa-fw') && leftIcon.push('fa-fw')
    }
    
    // Create a wrapper div for the button with tooltip
    return (
        <div className="relative inline-block group">
            <button className={cssClass.join(" ")} onClick={onClick} disabled={disabled}>
                {rightIcon != undefined && <i className={rightIcon.join(" ")} aria-hidden="true"></i>}
                {children}
                {icon != undefined && <i className={iconClasses.join(" ")} aria-hidden="true"></i>}
                {leftIcon != undefined && <i className={leftIcon.join(" ")} aria-hidden="true"></i>}
            </button>
            {tooltip != undefined && (
                <div className="absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-full 
                               opacity-0 group-hover:opacity-100 transition-opacity duration-200 
                               pointer-events-none z-10">
                    <div className="bg-gray-800 text-white text-xs rounded py-1 px-2 mt-1
                                  dark:bg-gray-700 whitespace-nowrap">
                        {tooltip}
                        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 
                                       border-4 border-transparent border-b-gray-800 
                                       dark:border-b-gray-700"></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TwButton;
